import { render, staticRenderFns } from "./zhuZhiDianJing.vue?vue&type=template&id=d93f6e14&scoped=true&"
import script from "./zhuZhiDianJing.vue?vue&type=script&lang=js&"
export * from "./zhuZhiDianJing.vue?vue&type=script&lang=js&"
import style0 from "./zhuZhiDianJing.vue?vue&type=style&index=0&id=d93f6e14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93f6e14",
  null
  
)

export default component.exports